import { useAuth } from './AuthProvider'
import { can } from '../lib/permissions'

export function usePermissions() {
  const { me } = useAuth()
  const permissions = me?.permissions ?? []

  return {
    permissions,
    canSearch: can(permissions, 'rag:search'),
    canCurate: can(permissions, 'rag:curate'),
    canApprove: can(permissions, 'rag:approve'),
    canReadUsers: can(permissions, 'user:read'),
    canInvite: can(permissions, 'member:invite'),
    canManageRpaCredentials: can(permissions, 'rpa:credentials:manage'),
    has: (required: string) => can(permissions, required),
  }
}
